import React, { useEffect, useMemo } from "react";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
import { PageLoading } from "@tripian/react";
import { TRIP_PLAN, LOGIN } from "../../constants/ROUTER_PATH_TITLE";
import usePlan from "../../hooks/usePlan";
import AppNav from "../../App/AppNav/AppNav";
import TripAppMenu from "../../App/AppNav/TripMenu/TripAppMenu";
import useTripHashParams from "../../hooks/useTripHashParams";
import useTranslate from "../../hooks/useTranslate";
import { useGuestUser } from "../../hooks/useGuestUser";
import useAuth from "../../hooks/useAuth";

const TripPlanRedirect = () => {
  const { plans } = usePlan();
  const { isLoggedIn } = useAuth();

  const navigate = useNavigate();

  const { t } = useTranslate();

  const isGuest = useGuestUser();

  const { hashParam } = useParams<{ hashParam?: string }>();
  const { hash, tripReference } = useTripHashParams(hashParam);

  const sharedTrip = useMemo(() => {
    if (!hashParam) return false;
    const params = hashParam.split("!");
    return params.length > 1 && hashParam.split("!")[1] === "s";
  }, [hashParam]);

  const hashLogin = useMemo(() => {
    if (!hashParam) return false;
    const params = hashParam.split("!");
    return params.length > 1 && params[1] === "l";
  }, [hashParam]);

  document.title = `${TRIP_PLAN.TITLE(t("tripPlan.header"))} - ${tripReference?.city.name || ""} - ${hash}`;
  /* */
  /* */
  /* ******* USE STATES ******* */
  /* */

  useEffect(() => {
    if (!isLoggedIn && !sharedTrip && !hashLogin && !isGuest) {
      navigate(LOGIN.PATH, {
        replace: true,
        state: { fromTripPlan: true, tripHash: hashParam },
      });
      return;
    }
  }, [isLoggedIn, sharedTrip, hashLogin, navigate, isGuest, hashParam]);

  // Trip Day Index
  useEffect(() => {
    if (plans) {
      const getInitialDayIndex = () => {
        const plansFirstDay = moment(plans[0].date);
        const plansLastDay = moment(plans[plans.length - 1].date);
        const datetimeNow = moment().startOf("day");
        if (
          datetimeNow.diff(plansFirstDay, "days") >= 0 &&
          plansLastDay.diff(datetimeNow, "days") >= 0
        ) {
          return plans.findIndex(
            p => p.date === datetimeNow.format("YYYY-MM-DD")
          );
        }
        return 0;
      };

      const initialDayIndex = getInitialDayIndex();
      navigate(`${TRIP_PLAN.PATH}/${hashParam}/${initialDayIndex}`, {
        replace: true,
      });
    }
  }, [hashParam, navigate, plans]);

  return (
    <>
      <AppNav
        tripInfoHeader={false}
        tripAppMenu={
          <TripAppMenu
            onClickBookings={() => {}}
            onClickOffers={() => {}}
            onClickFavorites={() => {}}
            t={t}
          />
        }
      />
      <PageLoading />
    </>
  );
};

export default TripPlanRedirect;
